import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useApp } from "../../context/AppContext";
import { AppError } from "./types/ErrorType";
import ErrorApiFailurePage from "./ui/ErrorApiFailurePage";
import ErrorNoNetworkPage from "./ui/ErrorNoNetworkPage";

interface ErrorFallbackProps {
  error: AppError;
}

const ErrorFallback = ({ error: { message, error_code, error_response } }: ErrorFallbackProps) => {
  const { isAnalyticsInitialized, setIsAnalyticsInitialized } = useApp();
  const [t] = useTranslation("translations");

  console.log(`message: ${message}, error_code: ${error_code}, error_response: ${error_response}`);

  const finalMessage = error_code ? message : t("ErrorPage.page_missing");
  
  // Use useEffect to handle side effects (analytics initialization)
  useEffect(() => {
    if (window.config && !isAnalyticsInitialized) {
      setIsAnalyticsInitialized(true);
    }
  }, [isAnalyticsInitialized, setIsAnalyticsInitialized]);

  switch (error_code) {
    case "ERROR_API_FAILURE":
      return <ErrorApiFailurePage />;
    case "ERROR_NO_NETWORK":
      return <ErrorNoNetworkPage />;
    default:
      return <ErrorApiFailurePage message={finalMessage} />;
  }
};

export default ErrorFallback;
